import { render, staticRenderFns } from "./DealCompany.vue?vue&type=template&id=204ff2f0&scoped=true"
import script from "./DealCompany.vue?vue&type=script&lang=js"
export * from "./DealCompany.vue?vue&type=script&lang=js"
import style0 from "./DealCompany.vue?vue&type=style&index=0&id=204ff2f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ff2f0",
  null
  
)

export default component.exports